// components/Footer.js
import React from "react";

const Footer = () => {
	return (
		<footer className="footer">
			<p>&copy; The MIT Post 2025</p>
		</footer>
	);
};

export default Footer;
